import { createSlice } from "@reduxjs/toolkit";

let initialQA = {
    que: "This is RysunAI!, your creative and helpful collaborator. While I have limitations and may not always achieve the desired results, your feedback will enable me to improve.",
    ans: {
        response: {
            output_text: `<p>Don't know where to begin? Here are some suggestions:</p>
            <a>What are some of the projects we have completed in the healthcare industry?</a>
            <a>Would you mind listing down the projects built using Java technology?</a>`


        },
        isFirst: true
    }
}

const counterSlice = createSlice({

    name: "counter",

    //answer[index]?.ans?.response?.output_text
    initialState: {
        query: [initialQA],
        ans: [],
        liked: [],
        loader: false,
        botLoader: false,
        called: 0,
        productPageMessages: [],
        highlight: [],
        sentance_time: 0,
        setPer: 0,
        formDataList: [],
        botLogoName: '',
        userHandlerName: '',
        avtarLogoName: '',
        uploadPolicyFileName: '',
        csvName: '',
        brandGuidelineName: '',
        socialMediaPostName: '',
        qmateValue: '',
        qmateCalled: false,
        docuMateCalled: false,
        docuMatePDF: {},
        docuMateLan: '',
        docuMateRadio: '',
        docuMateRadioClick: '',
        docuMateUserQuery: [],
        docuMateText: '',
        qMateCounter: false,
        docuMateCounter: false,
        voiceCalled: false,
        audioSentiment: {},
        audioExtract: {},
        chatBotPreview: false,
        modalOption: "no",
        rowsPerPageVoice: 5,
        firstVoice: 0,
        voiceAudioTime: "00:00.00",
        stopId: "",
        emailValue: "",
        emailCounter: false,
        hideDocCompare: false,
        hideDocSyn: false,
        sentimentAnalysisPdf: {},
        botProduct: "",
        selectedConnector: "",
        handlerState: "",
        isNewConversation: "new",
        addToCartObj: {},
        deleted: false,
        notFound: false,
        isAnswerCalling: false,
        hisoryCalled: true,
        isShowButton: false,
    },
    reducers: {
        setIsShowButton(state) {
            state.isShowButton = !state.isShowButton
        },
        // handleSetIsShowButton(state, action) {
        //     state.isShowButton = action.payload
        // },
        setHistoryCalled(state, action) {
            state.hisoryCalled = action.payload
        },
        handleNotFound(state, action) {
            state.notFound = action.payload
        },
        conversationDeleted(state, action) {
            state.deleted = action.payload
        },
        handleAnswerCalling(state, action) {
            state.isAnswerCalling = action.payload
        },
        addOrRemoveObjectForAddToCart(state, action) {
            state.addToCartObj = action.payload
        },
        setIsNewConversation(state, action) {
            state.isNewConversation = action.payload
        },
        controlHandlerState(state, action) {
            state.handlerState = action.payload
        },
        setUserHandlerName(state, action) {
            state.userHandlerName = action.payload
        },
        setBotProduct(state, action) {
            state.botProduct = action.payload
        },
        setSelectedConnector(state, action) {
            state.selectedConnector = action.payload
        },
        setEmailValue(state, action) {
            state.emailValue = action.payload
        },
        handleEmailCounter(state, action) {
            state.emailCounter = action.payload
        },
        setStopId(state, action) {
            state.stopId = action.payload
        },
        handleChatPreview(state) {
            state.chatBotPreview = !state.chatBotPreview
        },
        handleChatclose(state, action) {
            state.chatBotPreview = action.payload
        },
        handleVoiceAudioTime(state, action) {
            state.voiceAudioTime = action.payload
        },
        handleVoice(state, action) {
            state.voiceCalled = action.payload
        },
        setRowsPerPageVoice(state, action) {
            state.rowsPerPageVoice = action.payload
        },
        setFirstVoice(state, action) {
            state.firstVoice = action.payload
        },
        setModalOption(state, action) {
            state.modalOption = action.payload
        },
        handleQMateCounter(state, action) {
            state.qMateCounter = action.payload
        },
        handleDocuMateCounter(state, action) {
            state.docuMateCounter = action.payload
        },
        setAudioExtract(state, action) {
            state.audioExtract = action.payload
        },
        setAudioSentiment(state, action) {
            state.audioSentiment = action.payload
        },
        handleDocuMateRadio(state, action) {
            state.docuMateRadio = action.payload
        },
        handleDocuMateRadioClick(state, action) {
            state.docuMateRadioClick = action.payload;
        },
        handleDocuMateUserQuery(state, action) {
            state.docuMateUserQuery = action.payload;
        },
        handleHideDocCompRadio(state, action) {
            state.hideDocCompare = action.payload
        },
        handleHideDocSynRadio(state, action) {
            state.hideDocSyn = action.payload
        },
        handleDocuMatePDF(state, action) {
            state.docuMatePDF = action.payload
        },
        handleDocumateLan(state, action) {
            state.docuMateLan = action.payload
        },
        handleDocuMateCalled(state, action) {
            state.docuMateCalled = action.payload
        },
        setQmateValue(state, action) {
            state.qmateValue = action.payload
        },
        setDocuMateValue(state, action) {
            state.docuMateText = action.payload
        },
        setBotLogoName(state, action) {
            state.botLogoName = action.payload
        },
        setAvtarLogoName(state, action) {
            state.avtarLogoName = action.payload
        },
        setUploadPolicyFileName(state, action) {
            state.uploadPolicyFileName = action.payload
        },
        setcsvName(state, action) {
            state.csvName = action.payload
        },
        setbrandGuidelineName(state, action) {
            state.brandGuidelineName = action.payload
        },
        setsocialMediaPostName(state, action) {
            state.socialMediaPostName = action.payload
        },
        setFormDataList(state, action) {
            state.formDataList = action.payload
        },
        handlePer(state, action) {
            state.setPer = action.payload
        },
        handleWords(state, action) {
            state.highlight = action.payload
        },
        handleDuration(state, action) {
            state.sentance_time = action.payload
        },
        handleCalled(state, action) {
            state.called = action.payload
        },
        handleLoader(state, action) {
            state.loader = action.payload;
        },
        handBotleLoader(state, action) {
            state.botLoader = action.payload;
        },
        handleQandA(state, action) {
            state.query.push(action.payload)

        },
        setConversation(state, action) {
            state.query = action.payload;

        },
        handleAns(state) {
            state.query = [initialQA]
        },
        handleSentimentAnalysisPDF(state, action) {
            state.sentimentAnalysisPdf = action.payload
        },
        handleDeleteQandA(state: any, action) {
            const deletedQuery = action.payload;
            state.query = state.query.filter((item: any) => item.que !== deletedQuery.que);
            state.ans = state?.ans.filter((item: any) => item.que !== deletedQuery.que);
        },
        like(state: any, action) {
            const id = action.payload;
            if (!state.liked.includes(id)) {
                state.liked.push(id);
            }
            try {
                localStorage.setItem("liked", JSON.stringify(state.liked));
            } catch (error) {
                console.error("Error setting data in localStorage:", error);
            }
        },
        disLike(state: any, action) {
            const id = action.payload;
            const index = state.liked.indexOf(id);
            if (index !== -1) {
                state.liked.splice(index, 1);
            }
            try {
                localStorage.setItem("liked", JSON.stringify(state.liked));
            } catch (error) {
                console.error("Error setting data in localStorage:", error);
            }
        },
        likedArray(state: any) {
            let likess: any = []
            state.liked = likess || []
        },
        addProductPageQuestion: (state: any, action) => {
            state.productPageMessages.push(action.payload)
        },
        updateProductPageQuestion: (state: any, action) => {
            const updatedMessage = action.payload;
            const index = state.productPageMessages.findIndex((message: { id: any; }) => message.id === updatedMessage.id);
            if (index !== -1) {
                state.productPageMessages[index] = updatedMessage;
            }
        },
        resetProductPageQuestion: (state) => {
            state.productPageMessages = []
        }
    }
})

export const { setIsShowButton, setHistoryCalled, handleChatclose, addOrRemoveObjectForAddToCart, handleAnswerCalling, conversationDeleted, handleNotFound, controlHandlerState, setUserHandlerName, setIsNewConversation, handBotleLoader, setBotProduct, setSelectedConnector, setEmailValue, handleEmailCounter, setStopId, handleVoiceAudioTime, handleDocuMateCounter, setFirstVoice, setRowsPerPageVoice, setModalOption, handleChatPreview, handleVoice, setAudioSentiment, setAudioExtract, handleQMateCounter, setDocuMateValue, handleDocuMateRadio, handleDocumateLan, handleDocuMatePDF, handleDocuMateCalled, setQmateValue, setcsvName, setbrandGuidelineName, setsocialMediaPostName, setAvtarLogoName, setBotLogoName, setUploadPolicyFileName, setFormDataList, handlePer, handleQandA, handleAns, handleWords, handleDeleteQandA, setConversation, like, disLike, likedArray, handleLoader, handleCalled, handleDuration, handleHideDocCompRadio, handleHideDocSynRadio, handleDocuMateRadioClick, handleDocuMateUserQuery, handleSentimentAnalysisPDF, addProductPageQuestion, updateProductPageQuestion, resetProductPageQuestion } = counterSlice.actions;

export default counterSlice.reducer;